var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mail_form" },
    [
      _c("v-cover", {
        staticClass: "mail_form__cover",
        attrs: {
          image: require("@/assets/images/portrait-diagnosis.png"),
          title: _vm.$t("diagnosis.onTheWay"),
        },
      }),
      true
        ? _c(
            "div",
            { ref: "formContainer", staticClass: "mail_form__fields" },
            [
              _c(
                "form",
                {
                  staticClass: "klaviyo-form",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitForm.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mail_form__heading",
                      class: { jp: _vm.isJapanese },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("mailForm.heading")) + " ")]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.name,
                        expression: "name",
                      },
                    ],
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("mailForm.firstNamePlaceholder"),
                      required: "",
                    },
                    domProps: { value: _vm.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.name = $event.target.value
                      },
                    },
                  }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email",
                      },
                    ],
                    attrs: {
                      type: "email",
                      placeholder: _vm.$t("mailForm.emailPlaceholder"),
                      required: "",
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.email = $event.target.value
                      },
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "opt-in-container" },
                    [
                      _vm.isJapanese
                        ? [
                            _c("div", { staticClass: "opt-in" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.dataConsentAllowCollect,
                                    expression: "dataConsentAllowCollect",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "privacy-consent",
                                  required: "",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.dataConsentAllowCollect
                                  )
                                    ? _vm._i(
                                        _vm.dataConsentAllowCollect,
                                        null
                                      ) > -1
                                    : _vm.dataConsentAllowCollect,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.dataConsentAllowCollect,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.dataConsentAllowCollect =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.dataConsentAllowCollect = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.dataConsentAllowCollect = $$c
                                    }
                                  },
                                },
                              }),
                              _c(
                                "label",
                                { attrs: { for: "privacy-consent" } },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.privacyPolicyText),
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "opt-in" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.dataConsentAllowSendRecap,
                                    expression: "dataConsentAllowSendRecap",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "diagnosis-consent",
                                  required: "",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.dataConsentAllowSendRecap
                                  )
                                    ? _vm._i(
                                        _vm.dataConsentAllowSendRecap,
                                        null
                                      ) > -1
                                    : _vm.dataConsentAllowSendRecap,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.dataConsentAllowSendRecap,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.dataConsentAllowSendRecap =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.dataConsentAllowSendRecap = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.dataConsentAllowSendRecap = $$c
                                    }
                                  },
                                },
                              }),
                              _c(
                                "label",
                                { attrs: { for: "diagnosis-consent" } },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.diagnosisConsentText
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "opt-in" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.marketingConsent,
                                    expression: "marketingConsent",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "marketing-consent-jp",
                                  required: "",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.marketingConsent)
                                    ? _vm._i(_vm.marketingConsent, null) > -1
                                    : _vm.marketingConsent,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.marketingConsent,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.marketingConsent = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.marketingConsent = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.marketingConsent = $$c
                                    }
                                  },
                                },
                              }),
                              _c(
                                "label",
                                { attrs: { for: "marketing-consent-jp" } },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.marketingConsentText
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]),
                          ]
                        : [
                            _c("div", { staticClass: "opt-in__multiple" }, [
                              _c(
                                "span",
                                { staticClass: "opt-in__multiple-start" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("mailForm.dataConsent_start")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "opt-in__wrapper" }, [
                                _c("div", { staticClass: "opt-in" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.marketingConsent,
                                        expression: "marketingConsent",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "marketing-consent",
                                      required: "",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.marketingConsent
                                      )
                                        ? _vm._i(_vm.marketingConsent, null) >
                                          -1
                                        : _vm.marketingConsent,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.marketingConsent,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.marketingConsent =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.marketingConsent = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.marketingConsent = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _c(
                                    "label",
                                    { attrs: { for: "marketing-consent" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("mailForm.marketingConsent")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "opt-in" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.dataConsentAllowCollect,
                                        expression: "dataConsentAllowCollect",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "data-consent-allow-collect",
                                      required: "",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.dataConsentAllowCollect
                                      )
                                        ? _vm._i(
                                            _vm.dataConsentAllowCollect,
                                            null
                                          ) > -1
                                        : _vm.dataConsentAllowCollect,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.dataConsentAllowCollect,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.dataConsentAllowCollect =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.dataConsentAllowCollect = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.dataConsentAllowCollect = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "data-consent-allow-collect",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "mailForm.dataConsent_allow_collect"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "opt-in" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.dataConsentAllowSendRecap,
                                        expression: "dataConsentAllowSendRecap",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "data-consent-allow-send-recap",
                                      required: "",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.dataConsentAllowSendRecap
                                      )
                                        ? _vm._i(
                                            _vm.dataConsentAllowSendRecap,
                                            null
                                          ) > -1
                                        : _vm.dataConsentAllowSendRecap,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.dataConsentAllowSendRecap,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.dataConsentAllowSendRecap =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.dataConsentAllowSendRecap =
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.dataConsentAllowSendRecap = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "data-consent-allow-send-recap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "mailForm.dataConsent_allow_send_recap"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticClass: "text-info-container" }, [
                              _c("p", { staticClass: "info-text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("mailForm.infoText_0")) +
                                    " "
                                ),
                              ]),
                              _c("p", { staticClass: "info-text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("mailForm.infoText_1")) +
                                    " "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: _vm.$t("mailForm.infoText_2_href"),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("mailForm.infoText_2"))
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("mailForm.infoText_3")) +
                                    " "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.$t("mailForm.infoText_4_href"),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("mailForm.infoText_4"))
                                    ),
                                  ]
                                ),
                                _vm._v(". "),
                              ]),
                            ]),
                          ],
                    ],
                    2
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.submissionSuccess,
                          expression: "submissionSuccess",
                        },
                      ],
                      staticClass: "success",
                    },
                    [_vm._v(_vm._s(_vm.$t("mailForm.submissionSuccess")))]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.submissionFail,
                          expression: "submissionFail",
                        },
                      ],
                      staticClass: "fail",
                    },
                    [_vm._v(_vm._s(_vm.$t("mailForm.submissionFail")))]
                  ),
                  _c(
                    "button",
                    { attrs: { type: "submit", disabled: _vm.isLoading } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isLoading
                              ? _vm.$t("mailForm.loading")
                              : _vm.$t("mailForm.confirm")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "v-button",
                {
                  staticStyle: { color: "white" },
                  attrs: {
                    color: "transparent",
                    secondary: true,
                    disabled: _vm.isLoading,
                  },
                  on: { click: () => _vm.$router.push("result") },
                },
                [_vm._v(" " + _vm._s(_vm.$t("diagnosis.skip")) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }